// import MainBody from './indexBody';
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link, useNavigate } from 'react-router-dom';
import apiRequest from '../../../../utils/apiRequest';
import { SELLER_PRODUCTS_GET, IMAGE_ADDRESS } from '../../../../apis';
import { handleChangeDataPageCategoryProducts } from '../../../../redux/actions/pages/category/categoryProducts';
import { handleChangeDataBottomSheetProducts } from '../../../../redux/actions/pages/category/productsMobile';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import 'swiper/css';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Sheet } from 'react-modal-sheet';


const SellerPageMobile = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { sellerCode } = useParams();

	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { products, productCount, filters, seller } = useSelector(state => state.categoryProducts);
	const { isSheetOpen, filterIndex, filter } = useSelector(state => state.productsMobile);
	const isSelectChild = filter?.options?.find(f => f.isSelect);

	useEffect(() => {
		callApiGetProducts();
	}, [SellerPageMobile, sellerCode]);

	const callApiGetProducts = (getParams = "") => {
		if(! isBackdropLoading)
			apiRequest({
			    dispatch,
			    endpoint: (SELLER_PRODUCTS_GET + sellerCode + getParams),
			    method: 'get',
			    onSuccess: (res) => {
			    	dispatch(handleChangeDataPageCategoryProducts('products', res.products));
			    	dispatch(handleChangeDataPageCategoryProducts('productCount', res.productCount));
			    	dispatch(handleChangeDataPageCategoryProducts('seller', res.seller));
			    	if(getParams === "")
			    		dispatch(handleChangeDataPageCategoryProducts('filters', res.filters));
			    },
		  	});
	};

	const handleToggleFilterOptions = (index) => {
		let newFilters = [...filters];
		newFilters.map((newFilter, newFilterIndex) => {
			newFilter.showOptions = (index === newFilterIndex && !newFilter.showOptions);
		});
		dispatch(handleChangeDataPageCategoryProducts('filters', newFilters));
	};

	const closeBottomSheet = () => {
		dispatch(handleChangeDataBottomSheetProducts('isSheetOpen', false));
	};

	const handleFilterClick = (index) => {
		dispatch(handleChangeDataBottomSheetProducts('filterIndex', index));
		dispatch(handleChangeDataBottomSheetProducts('filter', filters[index]));
		dispatch(handleChangeDataBottomSheetProducts('isSheetOpen', true));
	};

	const handleToggleOptionItemSelect = (optionIndex) => {
		let newFilters = [...filters];
		let isSelect = newFilters[filterIndex].options[optionIndex].isSelect;
		newFilters[filterIndex].options[optionIndex].isSelect = !isSelect;
		dispatch(handleChangeDataPageCategoryProducts('filters', newFilters));



		const selectedIds = filters
		  .flatMap(filter => filter.options) // همه گزینه‌ها در یک آرایه
		  .filter(option => option.isSelect) // فقط انتخاب‌شده‌ها
		  .map(option => option.id); // گرفتن id

		const queryString = selectedIds.length > 0 ? `?filter=${selectedIds.join(',')}` : '';

		callApiGetProducts(queryString);
	};

	const clearFilter = (event) => {
		event.preventDefault();

		let newFilters = filters;
		newFilters[filterIndex].options.map((option, optionIndex) => {
			option.isSelect = false;
		});
		dispatch(handleChangeDataPageCategoryProducts('filters', newFilters));

		const selectedIds = filters
		  .flatMap(filter => filter.options) // همه گزینه‌ها در یک آرایه
		  .filter(option => option.isSelect) // فقط انتخاب‌شده‌ها
		  .map(option => option.id); // گرفتن id

		const queryString = selectedIds.length > 0 ? `?filter=${selectedIds.join(',')}` : '';

		callApiGetProducts(queryString);
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};


	const copyToClipboard = (text: string) => {
	  	if (navigator.clipboard) {
		    return navigator.clipboard.writeText(text);
	  	} else {
		    const textarea = document.createElement("textarea");
		    textarea.value = text;
		    textarea.style.position = "fixed";
		    textarea.style.opacity = "0";
		    document.body.appendChild(textarea);
		    textarea.select();
		    document.execCommand("copy");
		    document.body.removeChild(textarea);
		    return Promise.resolve();
	  	}
	};

	const handleShare = () => {
	  	copyToClipboard(window.location.href).then(() => {
		    // alert("لینک صفحه با موفقیت کپی شد ✅");
		    dispatch(
                handleSetOpenCustomSnackbar(true, {
                    message: "لینک صفحه با موفقیت کپی شد ✅",
                    severity: 'info',
                    vertical: 'bottom',
                    horizontal: 'center',
                })
            );
	  	});
	};

    return (

    	<div className="flex flex-col grow">

			<div className="sticky top-0 left-0 w-full z-3 bg-neutral-000" id="base_layout_mobile_sticky_header" style={{top: '0px'}}>
				<div>
					<div className="flex items-center justify-between px-5 py-4 sticky top-0 z-2 bg-neutral-000 " style={{height: '64px'}}>
						<div className="flex items-center">
							<div onClick={() => navigate(-1)} className="flex cursor-pointer cursor-pointer">
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#arrowRight"></use>
								</svg>
							</div>
						</div>
						<div className="flex items-center">
							<div className="relative ml-6">
								<div className="w-full">
									<div>
										<div className="flex justify-between items-center">
										</div>

									</div>
									<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o !right-6 !top-[-2px] styles_Tooltip__tooltip__arrow--bottom__rZ4eR styles_Tooltip__tooltip--hasArrow___6xzR styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom" style={{position: 'absolute', inset: '0px auto auto 0px', transform: 'translate3d(80px, 44px, 0px)'}}>
										<div className="flex items-center">
											<span>ویژگی‌های محصولت رو توصیف کن، مثل رنگ و جنس تا پیداش کنیم.
											</span>
											<div className="flex cursor-pointer" >
												<div className="cube-font-icon" data-icon-name="cube-nav-close" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-white)'}}>
												</div>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
							</div>
							<div className="flex cursor-pointer cursor-pointer" onClick={handleShare} >
								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#share"></use>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div className="grow flex flex-col" style={{paddingBottom: '55px', paddingTop: '0px'}}>
				<div className="styles_BaseLayoutMobile__fixMobileHeader__eilSC">
					<div id="base_layout_mobile_static_header">
						<div>
						</div>
					</div>
				</div>
				<div className="grow bg-neutral-000 flex flex-col styles_BaseLayoutMobile__content__JgqoX px-5 lg:px-0">
					<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
					</div>
					


					<div className="flex lg:rounded-large overflow-hidden lg:border-complete flex-col user-select-none px-5 lg:px-0 my-3 lg:mb-5 border-complete-b styles_container__erDaw">
						<div className="flex flex-col lg:flex-row lg:items-center py-4 lg:px-5">
							<div className="flex lg:items-center justify-between">
								<div className="flex items-center">
									<div className="rounded flex items-center justify-center relative border-complete styles_SellerIcon__q8nr3">
										<div className="flex">
											<svg style={{width: '32px', height: '32px', fill: 'var(--color-icon-high-emphasis)'}}>
												<use xlinkHref="#seller" />
											</svg>
										</div>
										<span className="absolute bg-neutral-000 rounded-circle styles_SellerIcon__verifiedIcon__6vbsD text-rating-4-5">
											<div className="flex rounded-circle bg-opacity-05">
												<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-rating-4-5)'}}>
													<use xlinkHref="#verifiedUser" />
												</svg>
											</div>
										</span>
									</div>
									<div className="w-full flex flex-col mr-5">
										<div className="w-full flex justify-between"><h1 className="text-h5 text-neutral-900 whitespace-nowrap">{seller.title}</h1>
										</div>
										<p className="text-body-2">{seller.registerDate}
										</p>
									</div>
								</div>
								{/*<div className="flex cursor-pointer mt-2 cursor-pointer lg:hidden">
									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
										<use xlinkHref="#infoOutline" />
									</svg>
								</div>*/}
							</div>
							<div className=" lg:mr-auto">
								<div className="flex mt-5 lg:mt-0">
									<div className="whitespace-nowrap flex flex-col bg-neutral-000 items-center justify-center  border-complete-l lg:border-complete-r lg:px-15 styles_SellerOption__optionItem__M141z">
										<div>
											<p className="text-h3" style={{color: 'var(--color-rating-3-4)'}}>{seller.goodsSatisfaction}٪
											</p>
										</div>
										<p className="text-neutral-500 text-body1-strong whitespace-nowrap">رضایت از کالاها
										</p>
									</div>
									<div className="whitespace-nowrap flex flex-col bg-neutral-000 items-center justify-center  border-complete-l lg:border-complete-r lg:px-15 styles_SellerOption__optionItem__M141z">
										<div>
											<p className="text-h3" style={{color: 'var(--color-rating-4-5)'}}>عالی
											</p>
										</div>
										<p className="text-neutral-500 text-body1-strong whitespace-nowrap">عملکرد فروشنده
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>



					<div id="ProductListPagesWrapper" className="relative w-full flex flex-col lg:flex-row items-center lg:items-stretch justify-between product-list_ProductList__wrapper__Evjm8">
						<section className="w-full grow relative">
							<div className="lg:static sticky lg:top-14 top-16 bg-neutral-000 z-2 top-14">
								<div>
									<div className="flex items-center overflow-scroll pl-3 hide-scrollbar overscroll-none flex items-center -mx-5 pr-3 pb-2 lg:pt-3 pt-1 gap-1 bg-neutral-000 lg:static hide-scrollbar overscroll-none">
										<div className="flex flex-row items-center gap-x-4">
											<div className="relative">
												<div className="flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--small__TArn9 flex-row-reverse py-1 px-2 text-body1-strong cursor-pointer text-body-2 pointer whitespace-nowrap lg:my-2 inline-block py-1 px-3 shadow-none" data-cro-id="plp-sort-icon">
													<span>پربازدیدترین
													</span>
													<div className="flex cursor-pointer ml-1">
														<svg style={{width: '15px', height: '15px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#sort"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>
										{/*<div className="relative">
											<div className="relative">
												<div className="flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--small__TArn9 flex-row-reverse py-1 px-2 text-body1-strong cursor-pointer text-body-2 pointer lg:my-2 inline-block py-1 px-3 shadow-none" data-cro-id="plp-filter-icon">
													<span>فیلتر
													</span>
													<div className="flex cursor-pointer ml-1">
														<svg style={{width: '15px', height: '15px', fill: 'var(--color-icon-high-emphasis)'}}>
															<use xlinkHref="#filter"></use>
														</svg>
													</div>
												</div>
											</div>
										</div>*/}
										<div className="flex items-center gap-1">
											{ 
												filters.map((filter, key) => {
													const isSelectChild = filter.options.find(f => f.isSelect);
													return (
														<div key={`filter-${key}`} className="relative">
															<div onClick={() => handleFilterClick(key)} className={`flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--small__TArn9 ${isSelectChild ? 'styles_Chip--active-borderless__rAELA text-body-1' : 'text-body1-strong'} py-1 px-2 text-body1-strong cursor-pointer text-body-2 pointer lg:my-2 inline-block py-1 px-3 shadow-none truncate`}>
																<span>{filter.title}
																</span>
																{ filter.type !== 'switch' &&
																<div className="flex cursor-pointer mr-1">
																	<svg style={{width: '15px', height: '15px', fill: `${isSelectChild ? 'var(--color-icon-primary)' : 'var(--color-icon-high-emphasis)'}`}}>
																		<use xlinkHref="#chevronDown"></use>
																	</svg>
																</div>
																}
															</div>
														</div>
													);
												})
											}
										</div>
									</div>
								</div>
							</div>
							<div className="flex items-center justify-between pt-3 text-neutral-500">
								<span className="grow text-body1-strong">همه کالاها
								</span>
								<div className="mr-auto block lg:hidden xl:block">
									<span className="whitespace-nowrap text-body-2 ellispis-1 flex items-center gap-2">{toPersianDigits(productCount)} کالا
									</span>
								</div>
							</div>
							<div className="product-list_ProductList__pagesContainer__zAhrX product-list_ProductList__pagesContainer--withoutSidebar__aty9j">
								{ 
									products.map((product, key) => (
										<div className="product-list_ProductList__item__LiiNI" data-product-index={`${key + 1}`}>
											<Link to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} className="block cursor-pointer relative bg-neutral-000 overflow-hidden grow flex flex-col items-stretch justify-start py-2" >
												<div data-testid="product-card">
													<article className="overflow-hidden flex flex-col items-stretch justify-start">
														<div className="flex items-center justify-start mb-1">
															<div className="text-body2-extra grow">
																<br />
															</div>
														</div>
														<div className="flex grow relative flex-row">
															<div className="ml-3 flex flex-col items-center">
																<div className="flex items-stretch flex-col relative">
																	<div className="flex flex-col">
																		<div>
																			<div style={{width: '118px', height: '118px', lineHeight: '0'}}>
																				<picture>
																					<LazyLoadImage src={IMAGE_ADDRESS + product.image} className="w-full rounded-medium inline-block" width="118" height="118" alt={product.title} title="" style={{objectFit: 'contain'}} />
																				</picture>
																			</div>
																		</div>
																		{product.colors &&
																			<div className="flex items-center justify-center gap-2 mt-3">
																				{
																					product.colors.split(",").map((color, colorIndex) => (
																						<span className="rounded-circle inline-block color_Color__l0PYL border-complete-200" style={{backgroundColor: `#${color}`, width: '8px', height: '8px'}}>
																						</span>
																					))
																				}
																			</div>
																		}
																	</div>
																</div>
															</div>
															<div className="grow flex flex-col items-stretch justify-start">
																<div className="flex items-center justify-start gap-1 flex-wrap mb-1">
																	<br />
																	<br />
																</div>
																<div>
																	<h3 className="ellipsis-2 text-body2-strong text-neutral-700 styles_HorizontalProductCard__productTitle__hzx5X">
																		{product.title}
																	</h3>
																</div>
																<div className="mb-1 flex items-center justify-between">
																	<div className="flex items-center" data-ab-id="">
																		{/*<p className="text-caption text-primary-700">تنها ۲ عدد در انبار باقی مانده
																		</p>*/}
																		<br />
																	</div>
																	<div className="flex items-center">
																		{/*<p className="text-body2-strong text-neutral-700">۴.۴
																		</p>
																		<div className="flex mr-2 shrink-0">
																			<svg style="width: 16px; height: 16px; fill: var(--color-icon-rating-0-2);">
																				<use xlinkHref="#starFill"></use>
																			</svg>
																		</div>*/}
																	</div>
																</div>
																<div className="pt-1 flex flex-col items-stretch justify-between">
																	<div className="flex items-center justify-between">
																		{ product.discount &&
																		<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error">
																			<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(product.discount)}٪
																			</span>
																		</div>
																		}
																		<div className="flex items-center justify-end gap-1 text-neutral-700 text-neutral-400 text-h5 grow">
																			<span data-testid="price-final">{product.price ? toPersianDigits(product.price) : 'ناموجود'}
																			</span>
																			<div className="flex">
																				<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
																					<use xlinkHref="#toman"></use>
																				</svg>
																			</div>
																		</div>
																	</div>
																	<div className="flex items-center justify-between pl-5">
																		{ product.oldPrice &&
																			<div data-testid="price-no-discount" className="text-neutral-300 line-through self-end mr-auto text-body-2">
																				{toPersianDigits(product.oldPrice)}
																			</div>
																		}
																	</div>
																</div>
															</div>
														</div>
													</article>
												</div>
											</Link>
										</div>
									))
								}
							</div>
						</section>
					</div>
				</div>
			</div>


			{ isSheetOpen && (
                <div
                    onClick={() => closeBottomSheet()}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 3,
                    }}
                />
            ) }

			<Sheet style={{zIndex: "4"}} isOpen={isSheetOpen} onClose={closeBottomSheet} detent="content-height" >
                <Sheet.Container >
                    <Sheet.Header className="">
                    	<div class="flex items-center px-5">
							<div class="break-words py-3 grow">
								<div class="flex items-center grow">
									<p class="grow text-h5 text-neutral-900">
										<span class="relative">{filter.title ?? ''}</span>
									</p>
								</div>
							</div>
							<div class="grow text-h5">
							</div>
							<div class="flex cursor-pointer">
								<svg onClick={closeBottomSheet} style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
                    </Sheet.Header>
                    <Sheet.Content>

                        <div class="grow flex flex-col overflow-y-auto">
							<div class="grow flex flex-col styles_children__hHq5Q py-4 px-5">
								<div>
									{
										filter?.options?.map((option, optionIndex) => (
											<div key={`filter-option-${optionIndex}`} class="w-full">
												<div class="w-full flex items-center justify-start">
													<div>
														<label class="flex items-center cursor-pointer styles_Checkbox__checkboxContainer__7joRB py-1 ml-4">
															<input class="invisible absolute" type="checkbox" id={`filter-option-${optionIndex}`} checked={option.isSelect} onChange={(e) => {e.stopPropagation(); handleToggleOptionItemSelect(optionIndex)}} />
															<span class="inline-flex justify-center items-center cursor-pointer rounded-small shrink-0 styles_Checkbox__checkbox__z1B5a styles_Checkbox__checkbox--secondary__FspFz">
																<div class="flex styles_Checkbox__icon__AaKB1">
																	<svg style={{width: '10px', height: '10px', fill: 'var(--color-icon-white)'}}>
																		<use xlinkHref="#check"></use>
																	</svg>
																</div>
															</span>
														</label>
													</div>
													<div class="grow text-neutral-700">
														<label for="17" class="w-full flex items-center justify-between py-3 lg:pl-3 border-complete-b">
															<div class="text-subtitle-strong">{option.title}
															</div>
														</label>
													</div>
													<div>
													</div>
												</div>
											</div>
										))
									}
								</div>
							</div>
						</div>

						<div class="w-full z-1 bg-neutral-000 px-5 py-4 shadow-1-top" >
							<div class="flex items-center justify-between gap-2.5">
								<button class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--primary__y0GEv rounded-medium flex-auto">
									<div class="flex items-center justify-center relative grow">مشاهده {toPersianDigits(productCount)} محصول
									</div>
								</button>
								<button onClick={clearFilter} disabled={!isSelectChild} class={`relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--outlined__saFC3 styles_btn--primary__y0GEv ${!isSelectChild ? 'styles_btn--disabled__lljQT' : ''} rounded-medium flex-auto`}>
									<div class="flex items-center justify-center relative grow">حذف فیلتر
									</div>
								</button>
							</div>
						</div>

                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>
    	
		</div>

    );
}

export default SellerPageMobile;